<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import AppHeader from '@/components/layout/AppHeader.vue'
import { useAuthStore } from '@/stores/auth'

const route = useRoute()
const authStore = useAuthStore()

// On boot: if we have a token, try to load the user. Router guards take care of
// redirecting to /login when there's no auth.
onMounted(async () => {
  if (authStore.token && !authStore.user) {
    await authStore.fetchMe()
  }
})

const useChrome = computed(() => {
  // Login/forgot/reset and standalone routes (insights) skip the standard shell.
  if (!authStore.isAuthenticated) return false
  return !(route.meta.standalone === true || route.meta.public === true)
})
</script>

<template>
  <RouterView v-if="!useChrome" />
  <div v-else class="min-h-screen bg-gray-50 dark:bg-gray-900">
    <AppHeader />
    <main class="container mx-auto px-4 py-6">
      <RouterView />
    </main>
  </div>
</template>
